import { useRequest } from 'features/request/useRequest';
import { useDebounce } from 'uikit';

import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { catalogIsUniqueWorkTypeCodeGql } from '../catalogTypesWorkQuery';

export const useIsUniqueCodeTypeWork = ({
    catalogWorkTypeId,
    code,
}: {
    catalogWorkTypeId: number;
    code: string;
}): boolean => {
    const dispatch = useDispatch();

    const variables = useMemo(
        () => ({
            catalogWorkTypeId,
            code,
        }),
        [catalogWorkTypeId, code],
    );

    const [isUniqueData, , , isUniqueRequest] = useRequest({
        requestId: 'IsUniqueCodeTypeWork',
        query: catalogIsUniqueWorkTypeCodeGql,
        variables,
        withEffect: false,
    });

    const debounceCheck = useDebounce(() => {
        if (code) {
            dispatch(isUniqueRequest(variables));
        }
    }, 500);

    useEffect(() => debounceCheck(), [debounceCheck, code]);

    return isUniqueData?.catalogIsUniqueWorkTypeCode.result;
};
